// Utility function to handle timezone-aware timestamp parsing
export const parseTimestamp = (timestamp: string): Date => {
  const date = new Date(timestamp);
  
  // Check if the date appears to be in the future (likely timezone issue)
  const now = new Date();
  if (date.getTime() > now.getTime() + 5 * 60 * 1000) { // More than 5 minutes in future
    // Likely a timezone issue - subtract the offset
    const offset = date.getTime() - now.getTime();
    const hourOffset = Math.round(offset / (60 * 60 * 1000));
    
    if (hourOffset > 0) {
      // Subtract the hour offset to get the correct time
      date.setHours(date.getHours() - hourOffset);
    }
  }
  
  return date;
};

// Calculate remaining time for delivery
export const calculateDeliveryTime = (acceptedAt: string, deliveryMinutes: number): { remaining: number; isOverdue: boolean } => {
  const acceptedTime = parseTimestamp(acceptedAt).getTime();
  const deliveryTime = acceptedTime + (deliveryMinutes * 60 * 1000);
  const now = Date.now();
  const remaining = deliveryTime - now;
  
  return {
    remaining: Math.abs(remaining),
    isOverdue: remaining < 0
  };
};
